import React from "react";
import "./Entry.css";
import { useHistory } from "react-router-dom";

export default function Entry() {
  const history = useHistory();
  function onSubmit(e) {
    const code = e.target["code"].value;
    e.preventDefault();
    history.push(`/match/${code}`);
  }

  return (
    <form className="match-form client-code-form" onSubmit={onSubmit}>
      <input
        className="match-form-input"
        name="code"
        type="text"
        placeholder="Kod meczu"
        maxLength="6"
        minLength="6"
        required
      />
      <button type="submit" className="match-form-btn">
        Zatwierdź
      </button>
    </form>
  );
}
